export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/qr-reader-worker.35b3f0d5.worker.js");
}
